(() => {
  const IST = "Asia/Kolkata";
  const DEAL_OPTION = /deal/i;
  const REGULAR_OPTION = /regular/i;

  const pad = (n) => String(n).padStart(2, "0");

  const nextMidnightIst = () => {
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: IST,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hourCycle: "h23",
    }).formatToParts(new Date());
    const map = Object.fromEntries(parts.map((p) => [p.type, p.value]));
    const start = Date.parse(
      `${map.year}-${map.month}-${map.day}T${map.hour}:${map.minute}:${map.second}+05:30`
    );
    const elapsed =
      Number(map.hour) * 3600 + Number(map.minute) * 60 + Number(map.second);
    return start + (86400 - elapsed) * 1e3;
  };

  const istDateKey = () =>
    new Intl.DateTimeFormat("en-CA", {
      timeZone: IST,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date());

  let countdownArmed = false;
  let countdownReloadQueued = false;

  const tickCountdowns = () => {
    let hitZeroAfterCountdown = false;
    document.querySelectorAll("[data-countdown]").forEach((root) => {
      const endUnix = Number(root.dataset.end || 0);
      const target = endUnix > 0 ? endUnix * 1e3 : nextMidnightIst();
      const diff = Math.max(0, target - Date.now());
      const total = Math.floor(diff / 1e3);
      const hours = Math.floor(total / 3600);
      const minutes = Math.floor((total % 3600) / 60);
      const seconds = total % 60;
      const h = root.querySelector("[data-hours]");
      const m = root.querySelector("[data-minutes]");
      const s = root.querySelector("[data-seconds]");
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(minutes);
      if (s) s.textContent = pad(seconds);
      const clock = document.querySelector("[data-end-clock]");
      if (clock && target) {
        clock.textContent =
          "Deal ends at " +
          new Intl.DateTimeFormat("en-IN", {
            timeZone: IST,
            day: "numeric",
            month: "short",
            hour: "numeric",
            minute: "2-digit",
            hourCycle: "h12",
          }).format(new Date(target)) +
          " IST";
      }
      if (total > 2) countdownArmed = true;
      if (total === 0 && countdownArmed) hitZeroAfterCountdown = true;
    });
    if (!hitZeroAfterCountdown || countdownReloadQueued) return;

try {
  const todayKey = istDateKey();
  const lockKey = `mytosh-countdown-reload-${todayKey}`;

  if (sessionStorage.getItem(lockKey) === "1") {
    return;
  }

  sessionStorage.setItem(lockKey, "1");
} catch {
  /* ignore */
}

countdownReloadQueued = true;
window.location.reload();
  };

  const initGallery = (root) => {
    const main = root.querySelector("[data-main-media]");
    if (!main) return;
    root.querySelectorAll("[data-thumb]").forEach((btn) => {
      btn.addEventListener("click", () => {
        root.querySelectorAll("[data-thumb]").forEach((el) => el.classList.remove("is-active"));
        btn.classList.add("is-active");
        const type = btn.dataset.mediaType;
        const src = btn.dataset.src;
        const poster = btn.dataset.poster || "";
        if (type === "video" || type === "external_video") {
          main.innerHTML = `<video src="${src}" poster="${poster}" controls playsinline></video>`;
        } else {
          main.innerHTML = `<img src="${src}" alt="">`;
        }
      });
    });
  };

  const cartRoot = () =>
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  const formatMoney = (cents) => {
    const format = window.themeMoneyFormat || "₹{{amount}}";
    const value = (Math.abs(Number(cents) || 0) / 100).toFixed(2);
    const [whole, dec] = value.split(".");
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, grouped)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, `${grouped}.${dec}`)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round((Number(cents) || 0) / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, value);
  };

  const cartJson = async () => (await fetch(`${cartRoot()}cart.js`)).json();

  const postCart = async (path, body) => {
    const res = await fetch(`${cartRoot()}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || "Cart could not be updated");
    return data;
  };

  const cartSectionId = () => document.querySelector("[data-cart-root]")?.dataset.sectionId || "";

  const syncHeaderCount = (count) => {
    const el = document.querySelector(".cart-count");
    if (el && count != null) el.textContent = String(count);
  };

  const paintCartTotal = () => {
    let total = 0;
    document.querySelectorAll("[data-cart-item]").forEach((el) => {
      total += Number(el.dataset.linePrice) || 0;
    });
    const totalEl = document.querySelector("[data-cart-total]");
    if (totalEl) totalEl.textContent = formatMoney(total);
  };

  const paintLinePrice = (article, cents) => {
    if (!article) return;
    article.dataset.linePrice = String(cents);
    const el = article.querySelector("[data-line-price-display]");
    if (el) el.textContent = formatMoney(cents);
  };

  const leftoverArticles = (group, except) =>
    [...document.querySelectorAll("[data-cart-item][data-bundle-group]")].filter(
      (el) => el.dataset.bundleGroup === group && el !== except
    );

  const paintBrokenBundlePrices = (removedArticle) => {
    if (removedArticle) {
      const group = removedArticle.dataset.bundleGroup;
      leftoverArticles(group, removedArticle).forEach((leftover) => {
        const revert = Number(leftover.dataset.revertPrice) || 0;
        const qty = Number(leftover.dataset.lineQty) || 1;
        if (revert > 0) paintLinePrice(leftover, revert * qty);
      });
      removedArticle.remove();
      paintCartTotal();
      return;
    }
    const groups = {};
    document.querySelectorAll("[data-cart-item][data-bundle-group]").forEach((el) => {
      const groupId = el.dataset.bundleGroup;
      (groups[groupId] = groups[groupId] || []).push(el);
    });
    Object.values(groups).forEach((lines) => {
      if (lines.length !== 1) return;
      const leftover = lines[0];
      const revert = Number(leftover.dataset.revertPrice) || 0;
      const qty = Number(leftover.dataset.lineQty) || 1;
      if (revert > 0) paintLinePrice(leftover, revert * qty);
    });
    paintCartTotal();
  };

  const applyCartHtml = (html) => {
    if (!html) return false;
    const sectionId = cartSectionId();
    const current = document.getElementById(`shopify-section-${sectionId}`);
    const temp = document.createElement("div");
    temp.innerHTML = html.trim();
    const next =
      temp.querySelector(`#shopify-section-${sectionId}`) || temp.firstElementChild;
    if (!current || !next) return false;
    current.replaceWith(next);
    bindCartPage();
    return true;
  };

  const refreshCartSection = async (cartPayload) => {
    if (cartPayload && cartPayload.item_count != null) syncHeaderCount(cartPayload.item_count);
    const fromPayload = cartPayload && cartPayload.sections && cartPayload.sections[cartSectionId()];
    if (fromPayload && applyCartHtml(fromPayload)) return true;
    const id = cartSectionId();
    if (!id) return false;
    const data = await (await fetch(`${cartRoot()}cart?sections=${encodeURIComponent(id)}`))
      .json()
      .catch(() => ({}));
    return applyCartHtml(data[id]);
  };

  const sectionPayload = () => {
    const id = cartSectionId();
    return id ? { sections: id, sections_url: `${cartRoot()}cart` } : {};
  };
const rolloverStaleTodayDeal = async () => {
  const mapEl = document.getElementById("mytosh-deal-cart-map");
  if (!mapEl) return false;
  let map = {};
  try {
    map = JSON.parse(mapEl.textContent || "{}");
  } catch (error) {
    return false;
  }
  const productId = Number(map.yesterdayProductId) || 0;
  const dealId = Number(map.dealVariantId) || 0;
  const regularId = Number(map.regularVariantId) || 0;
  if (!productId || !dealId || !regularId || dealId === regularId) return false;

  let cart;
  try {
    cart = await cartJson();
  } catch (error) {
    return false;
  }
  const guardKey = `mytosh-rollover-${cart.token || "cart"}-${regularId}`;
  try {
    if (sessionStorage.getItem(guardKey) === "1") return false;
  } catch (error) {
    /* ignore */
  }

  const stale = (cart.items || []).filter((item) => {
    const bundled = item.properties && item.properties._bundle_group;
    if (bundled) return false;
    return Number(item.product_id) === productId && Number(item.variant_id) === dealId;
  });
  if (!stale.length) return false;

  let lastCart = cart;
  for (let i = 0; i < stale.length; i += 1) {
    const item = stale[i];
    const qty = Number(item.quantity) || 1;
    lastCart = await postCart("cart/change.js", { id: item.key, quantity: 0 });
    lastCart = await postCart("cart/add.js", { items: [{ id: regularId, quantity: qty }] });
  }
  try {
    sessionStorage.setItem(guardKey, "1");
  } catch (error) {
    /* ignore */
  }
  syncHeaderCount(lastCart.item_count);
  window.location.reload();
  return true;
};
  const reconcileBrokenBundles = async ({ reload = false, render = true } = {}) => {
    let cart;
    try {
      cart = await cartJson();
    } catch {
      return false;
    }
    const groups = {};
    (cart.items || []).forEach((item) => {
      const groupId = item.properties && item.properties._bundle_group;
      if (groupId) (groups[groupId] = groups[groupId] || []).push(item);
    });
    let changed = false;
    let lastCart = cart;
    const broken = Object.keys(groups).filter((groupId) => groups[groupId].length < 2);
    for (let i = 0; i < broken.length; i += 1) {
      const item = groups[broken[i]][0];
      const revertId = Number(item.properties && item.properties._revert_variant_id);
      const qty = Number(item.quantity) || 1;
      lastCart = await postCart("cart/change.js", { id: item.key, quantity: 0 });
      if (revertId > 0) {
        const payload = { items: [{ id: revertId, quantity: qty }] };
        if (render && i === broken.length - 1) Object.assign(payload, sectionPayload());
        lastCart = await postCart("cart/add.js", payload);
      }
      changed = true;
    }
    if (!changed) return false;
    syncHeaderCount(lastCart.item_count);
    if (render && (await refreshCartSection(lastCart))) return true;
    if (reload) window.location.reload();
    return changed;
  };

  const variantOptions = (variant) =>
    [variant.option1, variant.option2, variant.option3].map((option) =>
      option == null ? null : String(option)
    );

  const dealOptionIndex = (variant) =>
    variantOptions(variant).findIndex(
      (option) => option && DEAL_OPTION.test(option) && !REGULAR_OPTION.test(option)
    );

  const findRegularVariant = (product, dealVariant) => {
    const idx = dealOptionIndex(dealVariant);
    const dealOpts = variantOptions(dealVariant);
    const variants = product.variants || [];
    if (idx >= 0) {
      const matched = variants.find((variant) => {
        const opts = variantOptions(variant);
        if (!opts[idx] || !REGULAR_OPTION.test(opts[idx])) return false;
        return opts.every((option, i) => i === idx || option === dealOpts[i]);
      });
      if (matched) return matched;
    }
    return variants.find((variant) =>
      variantOptions(variant).some((option) => option && REGULAR_OPTION.test(option))
    );
  };

  const parseTodayProductId = (doc) => {
    const configured = Number(doc.defaultView?.MyToshDeals?.todayProductId || window.MyToshDeals?.todayProductId || 0);
    if (configured) return configured;
    const form =
      doc.querySelector("#todays-deal form.deal-form") ||
      doc.querySelector("#todays-deal form[action*='/cart/add']");
    const fromInput = form?.querySelector('input[name="product-id"]')?.value;
    if (fromInput) return Number(fromInput);
    const formId = form?.id || "";
    const match = formId.match(/product_form_(\d+)/);
    if (match) return Number(match[1]);
    return Number(doc.querySelector("#todays-deal")?.dataset.productId || 0);
  };

  const loadTodayProductId = async () => {
    const cacheKey = `mytosh-today-product:${istDateKey()}`;
    try {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached != null && cached !== "") return Number(cached) || 0;
    } catch {
      /* ignore */
    }
    const fromPage = parseTodayProductId(document);
    if (fromPage) {
      try {
        sessionStorage.setItem(cacheKey, String(fromPage));
      } catch {
        /* ignore */
      }
      return fromPage;
    }
    try {
      const html = await (await fetch(cartRoot())).text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      const id = parseTodayProductId(doc);
      try {
        sessionStorage.setItem(cacheKey, String(id || 0));
      } catch {
        /* ignore */
      }
      return id || 0;
    } catch {
      return 0;
    }
  };

  const productJson = async (handle) =>
    (await fetch(`${cartRoot()}products/${encodeURIComponent(handle)}.js`)).json();

  const intactBundleKeys = (items) => {
    const groups = {};
    items.forEach((item) => {
      const groupId = item.properties && item.properties._bundle_group;
      if (!groupId) return;
      (groups[groupId] = groups[groupId] || []).push(item);
    });
    return new Set(
      Object.values(groups)
        .filter((group) => group.length >= 2)
        .flat()
        .map((item) => item.key)
    );
  };

  const currentVariantFromItem = (product, item) => {
    const found = (product.variants || []).find((variant) => Number(variant.id) === Number(item.variant_id));
    if (found) return found;
    const options = item.variant_options || [];
    return {
      id: item.variant_id,
      option1: options[0] || item.variant_title,
      option2: options[1] || null,
      option3: options[2] || null,
    };
  };

  const reconcileExpiredDeals = async ({ reload = false, render = true } = {}) => {
  let cart;

  try {
    cart = await cartJson();
  } catch {
    return false;
  }

  const items = cart.items || [];
  if (!items.length) return false;

  const todayProductId = await loadTodayProductId();
  const protectedKeys = intactBundleKeys(items);

  let changed = false;
  let lastCart = cart;

  for (const item of items) {
    /*
     * Never modify an intact bundle.
     * Bundle pricing is handled separately.
     */
    if (protectedKeys.has(item.key)) continue;

    /*
     * IMPORTANT:
     * If this line was added from the Yesterday/Previous Deal
     * section, it is already the regular-price version.
     *
     * Therefore it must NOT be converted again.
     */
    const dealSlot = String(
      item.properties && item.properties._deal_slot || ""
    ).toLowerCase();

    if (dealSlot === "regular") {
      continue;
    }

    /*
     * Today's current product must stay untouched.
     */
    if (
      todayProductId &&
      Number(item.product_id) === Number(todayProductId)
    ) {
      continue;
    }

    /*
     * First try the hidden regular variant ID saved when
     * the product was added as Today's Deal.
     */
    const propertyRegularId = Number(
      item.properties && item.properties._regular_variant_id
    );

    let regularId = propertyRegularId > 0
      ? propertyRegularId
      : 0;

    /*
     * If the regular variant ID is not available in cart
     * properties, inspect the product JSON and find the
     * matching Regular variant.
     */
    if (!regularId) {
      let product;

      try {
        product = await productJson(item.handle);
      } catch {
        continue;
      }

      const current = currentVariantFromItem(product, item);

      /*
       * If the current cart variant is not a Deal variant,
       * there is nothing to convert.
       */
      if (dealOptionIndex(current) < 0) {
        continue;
      }

      const regular = findRegularVariant(product, current);

      if (!regular) {
        continue;
      }

      if (Number(regular.id) === Number(item.variant_id)) {
        continue;
      }

      regularId = Number(regular.id);
    }

    /*
     * Nothing to change if regular variant could not be found.
     */
    if (!regularId) continue;

    if (Number(regularId) === Number(item.variant_id)) {
      continue;
    }

    const qty = Number(item.quantity) || 1;

    /*
     * Remove the expired Deal variant.
     */
    lastCart = await postCart(
      "cart/change.js",
      {
        id: item.key,
        quantity: 0
      }
    );

    /*
     * Preserve useful properties, but remove bundle-specific
     * properties because this is now a normal Regular item.
     */
    const properties = {
      ...(item.properties || {})
    };

    delete properties._bundle_group;
    delete properties._bundle_role;

    /*
     * Mark the converted line as Regular so it will never
     * be converted again on the same page/session.
     */
    properties._deal_slot = "regular";

    /*
     * Add the Regular variant.
     */
    const payload = {
      items: [
        {
          id: regularId,
          quantity: qty,
          properties
        }
      ]
    };

    if (render) {
      Object.assign(payload, sectionPayload());
    }

    lastCart = await postCart(
      "cart/add.js",
      payload
    );

    changed = true;
  }

  if (!changed) {
    return false;
  }

  syncHeaderCount(lastCart.item_count);

  /*
   * Refresh the cart section without a full page reload.
   */
  if (
    render &&
    (await refreshCartSection(lastCart))
  ) {
    return true;
  }

  if (reload) {
    window.location.reload();
  }

  return changed;
};

  const syncDealPrices = async (options = {}) => {
    const broken = await reconcileBrokenBundles(options);
    const expired = await reconcileExpiredDeals(options);
    return broken || expired;
  };

  const initBundleAdd = () => {
    document.querySelectorAll("[data-add-items]").forEach((btn) => {
      btn.addEventListener("click", async () => {
        const ids = String(btn.dataset.addItems || "")
          .split(",")
          .map((id) => Number(id.trim()))
          .filter((id) => id > 0);
        if (!ids.length) return;
        const cartUrl = btn.dataset.cartUrl || `${cartRoot()}cart`;
        btn.disabled = true;
        try {
          let items = ids.map((id) => ({ id, quantity: 1 }));
          if (btn.dataset.role === "bundle" && ids.length >= 2) {
            const groupId = `b${Date.now()}`;
            const todayRevert = Number(btn.dataset.revertToday) || ids[0];
            const yesterdayRevert = Number(btn.dataset.revertYesterday) || ids[1];
            const todayRevertPrice = Number(btn.dataset.revertTodayPrice) || 0;
            const yesterdayRevertPrice = Number(btn.dataset.revertYesterdayPrice) || 0;
            items = [
              {
                id: ids[0],
                quantity: 1,
                properties: {
                  _bundle_group: groupId,
                  _bundle_role: "today",
                  _revert_variant_id: String(todayRevert),
                  _revert_price: String(todayRevertPrice),
                },
              },
              {
                id: ids[1],
                quantity: 1,
                properties: {
                  _bundle_group: groupId,
                  _bundle_role: "yesterday",
                  _revert_variant_id: String(yesterdayRevert),
                  _revert_price: String(yesterdayRevertPrice),
                },
              },
            ];
          }
          if (btn.dataset.role === "yesterday") {
  items = items.map((line) => ({
    ...line,
    properties: {
      ...(line.properties || {}),
      _deal_slot: "regular"
    }
  }));
}
          const res = await fetch(`${cartRoot()}cart/add.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items }),
          });
          const data = await res.json().catch(() => ({}));
          if (!res.ok) throw new Error(data.description || data.message || "Could not add bundle to cart");
          window.location.assign(cartUrl);
        } catch (error) {
          btn.disabled = false;
          window.alert(error.message || "Could not add bundle to cart");
        }
      });
    });
  };

  const readQtyUpdates = (form) => {
    const updates = {};
    form.querySelectorAll("input[name^='updates[']").forEach((input) => {
      const key = input.getAttribute("name").slice(8, -1);
      updates[key] = Number(input.value);
    });
    return updates;
  };

  const applyOptimisticQtyUpdates = (updates) => {
    Object.keys(updates).forEach((key) => {
      if ((Number(updates[key]) || 0) > 0) return;
      const article = [...document.querySelectorAll("[data-cart-item]")].find(
        (el) => el.dataset.lineKey === key
      );
      if (article) paintBrokenBundlePrices(article);
    });
    Object.keys(updates).forEach((key) => {
      const qty = Number(updates[key]) || 0;
      if (qty <= 0) return;
      const article = [...document.querySelectorAll("[data-cart-item]")].find(
        (el) => el.dataset.lineKey === key
      );
      if (!article) return;
      article.dataset.lineQty = String(qty);
      const group = article.dataset.bundleGroup;
      const stillBundled = !!(group && leftoverArticles(group, article).length > 0);
      const revert = Number(article.dataset.revertPrice) || 0;
      const unit = stillBundled
        ? Number(article.dataset.unitPrice) || 0
        : revert || Number(article.dataset.unitPrice) || 0;
      if (!stillBundled && revert > 0) article.dataset.unitPrice = String(revert);
      paintLinePrice(article, unit * qty);
    });
    paintCartTotal();
  };

  let cartBusy = false;

  const syncCartFromUpdates = async (updates, { checkout = false } = {}) => {
    if (cartBusy) return;
    cartBusy = true;
    applyOptimisticQtyUpdates(updates);
    try {
      const cart = await postCart("cart/update.js", { updates });
      const changed = await syncDealPrices({ reload: false, render: !checkout });
      if (checkout) {
        window.location.assign(`${cartRoot()}checkout`);
        return;
      }
      if (!changed) await refreshCartSection(cart);
    } catch (error) {
      window.alert(error.message || "Could not update cart");
    } finally {
      cartBusy = false;
    }
  };

  const bindCartPage = () => {
    const form = document.querySelector("[data-cart-form]");
    if (!form || form.dataset.bound === "true") return;
    form.dataset.bound = "true";
    form.addEventListener("click", async (event) => {
      const link = event.target.closest("[data-remove-line]");
      if (!link) return;
      event.preventDefault();
      const article = link.closest("[data-cart-item]");
      if (!article) return;
      const key = article.dataset.lineKey;
      const updates = readQtyUpdates(form);
      updates[key] = 0;
      await syncCartFromUpdates(updates);
    });
    form.addEventListener("change", async (event) => {
      if (!event.target.closest("input[name^='updates[']")) return;
      const updates = readQtyUpdates(form);
      await syncCartFromUpdates(updates);
    });
    form.addEventListener("submit", async (event) => {
      const submitter = event.submitter;
      const name = submitter && submitter.getAttribute("name");
      if (name !== "checkout" && name !== "update") return;
      event.preventDefault();
      await syncCartFromUpdates(readQtyUpdates(form), { checkout: name === "checkout" });
    });
  };

  const initCartBundleGuard = () => {
    paintBrokenBundlePrices();
    bindCartPage();
  };

  const parseVariants = (root) => {
    const el = root.querySelector("[data-variant-json]");
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch {
      return [];
    }
  };

  const matchVariant = (variants, picks, lock) => {
    const wanted = picks.map((p) => String(p).toLowerCase()).filter(Boolean);
    const lockKey = String(lock || "").toLowerCase();
    const hasLock = (variant) =>
      !lockKey || (variant.options || []).some((option) => String(option).toLowerCase().includes(lockKey));
    const hasPicks = (variant) =>
      wanted.every((pick) => (variant.options || []).some((option) => String(option).toLowerCase() === pick));
    return variants.find((variant) => hasLock(variant) && hasPicks(variant)) || variants.find((variant) => hasPicks(variant));
  };

  const setMainImage = (root, src) => {
    if (!src) return;
    const main = root.querySelector("[data-main-media]");
    if (!main) return;
    const existing = main.querySelector("img");
    if (existing) {
      existing.src = src;
      existing.removeAttribute("srcset");
      existing.removeAttribute("sizes");
      const video = main.querySelector("video");
      if (video) video.remove();
    } else {
      main.innerHTML = `<img src="${src}" alt="">`;
    }
    const file = String(src).split("?")[0];
    root.querySelectorAll("[data-thumb]").forEach((btn) => {
      const thumb = String(btn.dataset.src || "").split("?")[0];
      btn.classList.toggle("is-active", !!(file && thumb && (thumb === file || src === btn.dataset.src)));
    });
    const counter = root.querySelector("[data-pdp-counter]");
    if (counter) {
      const thumbs = [...root.querySelectorAll("[data-thumb]")];
      const active = thumbs.findIndex((thumb) => thumb.classList.contains("is-active"));
      if (active >= 0) counter.textContent = `${active + 1} / ${thumbs.length}`;
    }
  };

  const updatePriceBlock = (block, variant) => {
    if (!block || !variant) return;
    const price = Number(variant.price) || 0;
    let compare = Number(variant.compare) || 0;
    const fallback = Number(block.dataset.fallbackCompare) || 0;
    if (compare <= price && fallback > price) compare = fallback;
    const now = block.querySelector(".price-now");
    if (now) now.textContent = formatMoney(price);
    const was = block.querySelector(".price-was");
    const off = block.querySelector(".off-chip");
    const saveEl = block.querySelector(".save-chip");
    if (compare > price) {
      const save = compare - price;
      const percent = Math.round((save * 100) / compare);
      if (was) {
        was.hidden = false;
        was.textContent = formatMoney(compare);
      }
      if (off) {
        off.hidden = percent <= 0;
        off.textContent = `${percent}% OFF`;
      }
      if (saveEl) {
        saveEl.hidden = save <= 0;
        const label = block.dataset.saveLabel || "You Save";
        saveEl.textContent = `${label} ${formatMoney(save)}`;
      }
    } else {
      if (was) was.hidden = true;
      if (off) off.hidden = true;
      if (saveEl) saveEl.hidden = true;
    }
  };

  const compareFor = (variant, block) => {
    if (!variant) return 0;
    const price = Number(variant.price) || 0;
    let compare = Number(variant.compare) || 0;
    const fallback = Number(block && block.dataset.fallbackCompare) || 0;
    if (compare <= price && fallback > price) compare = fallback;
    return compare;
  };

  const currentPickedVariant = (root, lock) => {
    if (!root) return null;
    const variants = parseVariants(root);
    if (!variants.length) return null;
    const picks = [...root.querySelectorAll("[data-option-select]")].map((select) => select.value);
    return matchVariant(variants, picks, lock || root.dataset.lock);
  };

  const refreshBundle = () => {
    const center = document.querySelector(".bundle-center");
    const todayRoot = document.querySelector("#todays-deal [data-variant-root]");
    const yesterdayRoot = document.getElementById("previous-deal");
    if (!center || !todayRoot || !yesterdayRoot) return;
    const todayDeal = currentPickedVariant(todayRoot, todayRoot.dataset.lock);
    const yesterdayRegular = currentPickedVariant(yesterdayRoot, yesterdayRoot.dataset.lock);
    const yesterdayDeal = currentPickedVariant(yesterdayRoot, yesterdayRoot.dataset.altLock) || yesterdayRegular;
    if (!todayDeal || !yesterdayDeal) return;
    const extraPct = Number(center.dataset.bundlePct) || 0;
    let bundlePrice = (Number(todayDeal.price) || 0) + (Number(yesterdayDeal.price) || 0);
    if (extraPct > 0 && bundlePrice > 0) bundlePrice = Math.round((bundlePrice * (100 - extraPct)) / 100);
    const todayCompare = compareFor(todayDeal, todayRoot.querySelector(".price-block"));
    const yesterdayCompare = compareFor(yesterdayRegular || yesterdayDeal, yesterdayRoot.querySelector(".price-block"));
    let bundleCompare = 0;
    if (todayCompare > 0 && yesterdayCompare > 0) bundleCompare = todayCompare + yesterdayCompare;
    else bundleCompare = (Number(todayDeal.price) || 0) + (Number((yesterdayRegular || yesterdayDeal).price) || 0);
    updatePriceBlock(center.querySelector(".price-block"), { price: bundlePrice, compare: bundleCompare });
    const sum = center.querySelector("[data-bundle-sum]");
    if (sum) sum.textContent = `${formatMoney(todayDeal.price)} + ${formatMoney(yesterdayDeal.price)}`;
    const picksLabel = center.querySelector("[data-bundle-picks]");
    if (picksLabel) {
      const todayPicks = [...todayRoot.querySelectorAll("[data-option-select]")]
        .map((select) => select.value)
        .filter(Boolean);
      const yesterdayPicks = [...yesterdayRoot.querySelectorAll("[data-option-select]")]
        .map((select) => select.value)
        .filter(Boolean);
      const parts = [];
      if (todayPicks.length) parts.push(todayPicks.join(" / "));
      if (yesterdayPicks.length) parts.push(yesterdayPicks.join(" / "));
      picksLabel.textContent = parts.join(" + ");
    }
    const images = center.querySelectorAll(".bundle-visual img");
    if (images[0] && todayDeal.image) {
      images[0].src = todayDeal.image;
      images[0].removeAttribute("srcset");
    }
    const yesterdayImage = (yesterdayRegular && yesterdayRegular.image) || yesterdayDeal.image;
    if (images[1] && yesterdayImage) {
      images[1].src = yesterdayImage;
      images[1].removeAttribute("srcset");
    }
    center.querySelectorAll('[data-role="bundle"]').forEach((btn) => {
      btn.dataset.addItems = `${todayDeal.id},${yesterdayDeal.id}`;
      btn.dataset.revertToday = String(todayDeal.id);
      btn.dataset.revertYesterday = String((yesterdayRegular || yesterdayDeal).id);
      btn.dataset.revertTodayPrice = String(todayDeal.price);
      btn.dataset.revertYesterdayPrice = String((yesterdayRegular || yesterdayDeal).price);
    });
  };

  const applyVariant = (root, variant, altVariant) => {
    if (!variant) return;
    const idInput = root.querySelector('input[name="id"]');
    if (idInput) idInput.value = String(variant.id);
    const dealId = altVariant && altVariant.id ? altVariant.id : variant.id;
    if (root.querySelector('input[name="id"]')) {
      document.querySelectorAll('[data-role="bundle"]').forEach((btn) => {
        const parts = String(btn.dataset.addItems || "").split(",");
        parts[0] = String(variant.id);
        btn.dataset.addItems = parts.filter(Boolean).join(",");
      });
    }
    if (root.id === "previous-deal") {
      document.querySelectorAll('[data-role="yesterday"]').forEach((btn) => {
        btn.dataset.addItems = String(variant.id);
      });
      document.querySelectorAll('[data-role="bundle"]').forEach((btn) => {
        const parts = String(btn.dataset.addItems || "").split(",");
        if (parts.length) parts[1] = String(dealId);
        btn.dataset.addItems = parts.filter(Boolean).join(",");
      });
      document.querySelectorAll(".previous-card").forEach((card) => {
        setMainImage(card, variant.image);
        updatePriceBlock(card.querySelector(".price-block"), variant);
      });
    }
    updatePriceBlock(root.querySelector(".price-block"), variant);
    setMainImage(root, variant.image);
    const buyBtn = root.querySelector(".pdp-buy-btn");
    if (buyBtn) {
      const sold = variant.available === false;
      buyBtn.disabled = sold;
      const label = buyBtn.querySelector("[data-pdp-buy-label]");
      if (label) label.textContent = sold ? "Sold Out" : "BUY NOW";
    }
    refreshBundle();
    syncDealFormProperties(root);
  };

  const ensureHiddenInput = (form, name, value) => {
    let input = form.querySelector(`input[name="${name}"]`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  };

  const regularVariantFromRoot = (root) => {
    const variants = parseVariants(root);
    const picks = [...root.querySelectorAll("[data-option-select]")].map((select) => select.value);
    return (
      matchVariant(variants, picks, "Regular") ||
      variants.find((variant) => (variant.options || []).some((option) => REGULAR_OPTION.test(String(option))))
    );
  };

  const syncDealFormProperties = (root) => {
    const form = (root && root.querySelector("form.deal-form, form[action*='/cart/add']")) || root;
    if (!form || form.tagName !== "FORM") return;
    const variantRoot = form.closest("[data-variant-root]") || document.querySelector("#todays-deal [data-variant-root]");
    if (!variantRoot) return;
    const regular = regularVariantFromRoot(variantRoot);
    const isToday = Boolean(form.closest("#todays-deal"));
    if (isToday) ensureHiddenInput(form, "properties[_deal_slot]", "today");
    if (regular) ensureHiddenInput(form, "properties[_regular_variant_id]", String(regular.id));
  };

  const initDealFormProps = () => {
    document.querySelectorAll("#todays-deal form.deal-form, #todays-deal form[action*='/cart/add']").forEach((form) => {
      const root = form.closest("[data-variant-root]");
      syncDealFormProperties(root || form);
    });
  };

  const initOptionPickers = () => {
    document.querySelectorAll("[data-variant-root]").forEach((root) => {
      const variants = parseVariants(root);
      if (!variants.length) return;
      const apply = () => {
        const picks = [...root.querySelectorAll("[data-option-select]")].map((select) => select.value);
        const variant = matchVariant(variants, picks, root.dataset.lock);
        const alt = matchVariant(variants, picks, root.dataset.altLock);
        applyVariant(root, variant, alt);
      };
      root.querySelectorAll("[data-option-select]").forEach((select) => {
        select.addEventListener("change", apply);
      });
    });
  };

  const initModal = () => {
    document.querySelectorAll("[data-open-modal]").forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        const dialog = document.getElementById(btn.getAttribute("data-open-modal"));
        if (dialog && typeof dialog.showModal === "function") dialog.showModal();
      });
    });
    document.querySelectorAll("[data-close-modal]").forEach((btn) => {
      btn.addEventListener("click", () => btn.closest("dialog")?.close());
    });
    document.querySelectorAll("dialog.dialog").forEach((dialog) => {
      dialog.addEventListener("click", (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
  };

  const initCheckoutGuard = () => {
    document.addEventListener(
      "click",
      async (event) => {
        const trigger = event.target.closest('a[href*="/checkout"]');
        if (!trigger || trigger.dataset.dealSync === "done") return;
        event.preventDefault();
        event.stopPropagation();
        try {
          await syncDealPrices({ render: false });
        } catch {
          /* still send the shopper to checkout */
        }
        trigger.dataset.dealSync = "done";
        window.location.assign(trigger.href);
      },
      true
    );
  };

  const showProductSlide = (root, index) => {
    const thumbs = [...root.querySelectorAll("[data-thumb]")];
    if (!thumbs.length) return;
    const next = thumbs[(index + thumbs.length) % thumbs.length];
    if (!next) return;
    thumbs.forEach((el) => el.classList.remove("is-active"));
    next.classList.add("is-active");
    const main = root.querySelector("[data-main-media]");
    if (!main) return;
    const type = next.dataset.mediaType;
    const src = next.dataset.src;
    const poster = next.dataset.poster || "";
    if (type === "video" || type === "external_video") {
      main.innerHTML = `<video src="${src}" poster="${poster}" controls playsinline></video>`;
    } else {
      main.innerHTML = `<img src="${src}" alt="">`;
    }
    const counter = root.querySelector("[data-pdp-counter]");
    if (counter) {
      const active = thumbs.indexOf(next);
      counter.textContent = `${active + 1} / ${thumbs.length}`;
    }
  };

  const initProductSlider = (root) => {
    const thumbs = [...root.querySelectorAll("[data-thumb]")];
    thumbs.forEach((btn, index) => {
      btn.addEventListener("click", () => showProductSlide(root, index));
    });
    root.querySelector("[data-pdp-prev]")?.addEventListener("click", () => {
      const current = thumbs.findIndex((el) => el.classList.contains("is-active"));
      showProductSlide(root, current < 0 ? 0 : current - 1);
    });
    root.querySelector("[data-pdp-next]")?.addEventListener("click", () => {
      const current = thumbs.findIndex((el) => el.classList.contains("is-active"));
      showProductSlide(root, current < 0 ? 0 : current + 1);
    });
  };

  const initQtySteppers = () => {
    document.querySelectorAll("[data-qty]").forEach((wrap) => {
      const input = wrap.querySelector("[data-qty-input]");
      if (!input) return;
      const min = Number(input.min) || 1;
      const clamp = (value) => Math.max(min, Number(value) || min);
      wrap.querySelector("[data-qty-minus]")?.addEventListener("click", () => {
        input.value = String(clamp(Number(input.value) - 1));
      });
      wrap.querySelector("[data-qty-plus]")?.addEventListener("click", () => {
        input.value = String(clamp(Number(input.value) + 1));
      });
      input.addEventListener("change", () => {
        input.value = String(clamp(input.value));
      });
    });
  };

  const boot = () => {
    tickCountdowns();
    setInterval(tickCountdowns, 1e3);
    document.querySelectorAll("[data-gallery]").forEach(initGallery);
    document.querySelectorAll("[data-product-slider]").forEach(initProductSlider);
    initQtySteppers();
    initModal();
    initBundleAdd();
    initCartBundleGuard();
    initOptionPickers();
    initDealFormProps();
    initCheckoutGuard();
    syncDealPrices();
    document.querySelectorAll(".look-track").forEach((track) => {
      const row = track.querySelector(".look-row");
      if (!row) return;
      track.querySelector("[data-look-prev]")?.addEventListener("click", () => {
        row.scrollBy({ left: -220, behavior: "smooth" });
      });
      track.querySelector("[data-look-next]")?.addEventListener("click", () => {
        row.scrollBy({ left: 220, behavior: "smooth" });
      });
    });
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
